import { useState } from 'react'

export default function VisualizadorDocumento({ doc, onFechar }) {
  const API_BASE = process.env.REACT_APP_API_URL?.replace('/api', '') || ''
  const url = doc.url || `${API_BASE}/uploads/${doc.nome_arquivo}`
  const isPDF = doc.nome_original?.toLowerCase().endsWith('.pdf') || doc.tipo_mime === 'application/pdf'
  const isImagem = /\.(jpg|jpeg|png|gif|webp)$/i.test(doc.nome_original||'') || doc.tipo_mime?.startsWith('image/')

  function formatBytes(b) {
    if (!b) return ''
    return b < 1024*1024 ? (b/1024).toFixed(0)+' KB' : (b/1024/1024).toFixed(1)+' MB'
  }

  return (
    <div style={{
      position:'fixed', inset:0, background:'rgba(0,0,0,0.7)', zIndex:1000,
      display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center',
      padding:20, fontFamily:'system-ui,sans-serif'
    }} onClick={e => e.target === e.currentTarget && onFechar()}>
      <div style={{ background:'white', borderRadius:12, overflow:'hidden', width:'100%', maxWidth:860, maxHeight:'90vh', display:'flex', flexDirection:'column' }}>
        {/* Header */}
        <div style={{ display:'flex', alignItems:'center', gap:12, padding:'12px 16px', borderBottom:'1px solid #e5e7eb', flexShrink:0 }}>
          <span style={{ fontSize:20 }}>{isPDF ? '📄' : '🖼'}</span>
          <div style={{ flex:1, minWidth:0 }}>
            <div style={{ fontSize:13, fontWeight:500, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{doc.nome_original}</div>
            {doc.tamanho_bytes && <div style={{ fontSize:11, color:'#9ca3af' }}>{formatBytes(doc.tamanho_bytes)}</div>}
          </div>
          <a href={url} download={doc.nome_original} target="_blank" rel="noreferrer"
            style={{ padding:'6px 12px', border:'1px solid #d1d5db', borderRadius:8, fontSize:12, color:'#374151', textDecoration:'none', whiteSpace:'nowrap' }}>
            ⬇ Baixar
          </a>
          <button onClick={onFechar}
            style={{ width:30, height:30, border:'none', background:'#f3f4f6', borderRadius:8, fontSize:16, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}>
            ✕
          </button>
        </div>

        {/* Conteúdo */}
        <div style={{ flex:1, overflow:'auto', background:'#f9fafb', display:'flex', alignItems:'center', justifyContent:'center', minHeight:400 }}>
          {isPDF ? (
            <iframe
              src={url}
              style={{ width:'100%', height:'70vh', border:'none' }}
              title={doc.nome_original}
            />
          ) : isImagem ? (
            <img
              src={url}
              alt={doc.nome_original}
              style={{ maxWidth:'100%', maxHeight:'70vh', objectFit:'contain', padding:16 }}
            />
          ) : (
            <div style={{ textAlign:'center', padding:40 }}>
              <div style={{ fontSize:40, marginBottom:12 }}>📎</div>
              <div style={{ fontSize:14, color:'#374151', marginBottom:8 }}>{doc.nome_original}</div>
              <div style={{ fontSize:13, color:'#9ca3af', marginBottom:16 }}>Visualização não disponível para este formato.</div>
              <a href={url} download={doc.nome_original}
                style={{ padding:'9px 20px', background:'#185FA5', color:'white', borderRadius:8, fontSize:13, textDecoration:'none' }}>
                ⬇ Baixar arquivo
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
